import React, { useEffect, useRef, useState } from 'react';
import './css/WeatherPreview.css';
import './css/WeatherPreviewResponsive.css';
import { WEATHER_TRANSLATIONS } from '../../../../../Constants/apps';
import { useSelector } from 'react-redux';

const WeatherPreviewUnified = ({ data, xs = false, previewMode = false, settings = null }) => {

  const { weatherBgColor, weatherTextColor, weatherCardColor } = useSelector((state) => state.apps);

  const [currentTime, setCurrentTime] = useState(new Date());
  const isDay = data?.current.is_day == 1 ? 1 : 0;
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const [hide, setHide] = useState(false);
  const [xhide, setXHide] = useState(false);



  const isCelsius = previewMode ? settings.unit === "c" : data?.media?.weather?.settings?.unit?.toLowerCase() === "c";
  const languageRtl = previewMode ? settings.lang_direction === "rtl" : data?.media?.weather?.settings?.lang_direction === "rtl";
  // const display_name = previewMode ?
  //   settings.lang != "en"
  //     ?
  //     settings.location_display ? settings.location_display : "Enter City Name"
  //     : data?.location?.name
  //   : data?.media?.weather?.settings?.location_display;
  const lang = previewMode ? settings.lang ? settings.lang : "en" : data?.media?.weather?.settings?.lang;



  const display_name = previewMode ? settings.lang != "ar" ? (data?.location?.name) : (settings.location_display ? settings.location_display : "Enter City Name") : data?.media?.weather?.settings?.lang != "ar" ? data?.location?.name : data?.media?.weather?.settings?.location_display
  const langTranslate = WEATHER_TRANSLATIONS[lang];
  const containerWeatherAreaRef = useRef(null);

  useEffect(() => {
    const updateDimensions = () => {
      if (containerWeatherAreaRef.current) {
        const { offsetWidth, offsetHeight } = containerWeatherAreaRef.current;
        setDimensions({ width: offsetWidth, height: offsetHeight - 10 });
      }
    };
    updateDimensions()

    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    window.addEventListener('resize', updateDimensions);
    return () => {
      window.removeEventListener('resize', updateDimensions)
      clearInterval(interval)
    };
  }, []);


  useEffect(() => {
    if (dimensions.width / dimensions.height > 3.2) {

      setHide(true)
      if (dimensions.width / dimensions.height > 4.2) {
        setXHide(true)
      } else {
        setXHide(false)
      }
    } else {
      setHide(false)
      setXHide(false)
    }

  }, [dimensions])

  const today = new Date();
  const nextDay = new Date(today);
  nextDay.setDate(today.getDate() + 1);
  const next2Day = new Date(today);
  next2Day.setDate(today.getDate() + 2);

  const currentDay = today.toLocaleDateString(lang, { weekday: "long" });
  const nextDayDayForecast = nextDay.toLocaleDateString(lang, { weekday: "long" });
  const next2DayDayForecast = next2Day.toLocaleDateString(lang, { weekday: "long" });

  const weekDays = [currentDay, nextDayDayForecast, next2DayDayForecast];



  const time = currentTime.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  const getWeatherIcon = (isDay, code) => {
    try {
      return require(`../../../../../assets/img/weather-icons/${isDay}/${code || 1000}.png`);
    } catch {
      return require(`../../../../../assets/img/weather-icons/1/1000.png`);
    }
  };

  const forecastDays = data?.forecast?.forecastday || [];
  const todayHours = forecastDays[0]?.hour || [];

  const containerClass = previewMode ? 'full-height-weather-preview-mode' : `full-height-weather `;
  const paneLeftClass = previewMode ? 'left-pane-preview-mode' : 'left-pane';
  const paneRightClass = previewMode ? 'right-pane-preview-mode' : 'right-pane';
  const topLeftClass = previewMode ? 'top-left-preview-mode' : 'top-left';
  const cityTitleClass = previewMode ? 'weather-city-title-preview-mode' : 'weather-city-title';
  const dateRowClass = previewMode ? 'date-row-preview-mode' : 'date-row';
  const dateTagClass = previewMode ? 'date-tag-preview-mode' : 'date-tag';
  const weatherIconClass = previewMode ? 'weather-icon-current-preview-mode' : 'weather-icon-current';
  const weatherDescRightClass = previewMode ? 'weather-description-right-preview-mode' : 'weather-description-right';
  const topRightClass = previewMode ? 'top-right-preview-mode' : 'top-right';
  const justifyEndClass = previewMode ? 'justify-content-end-preview-mode' : 'justify-content-end';
  const currentTempValueClass = previewMode ? 'temp-weather-current-value-preview-mode' : 'temp-weather-current-value';
  const currentTempUnitClass = previewMode ? 'temp-weather-current-unit-preview-mode' : 'temp-weather-current-unit';
  const forecastRowClass = previewMode ? 'forecast-row-preview-mode' : 'forecast-row';
  const forecastCardClass = previewMode ? 'weather-forecast-card-preview-mode' : 'weather-forecast-card';
  const forecastIconClass = previewMode ? 'weather-forecast-icons-preview-mode' : 'weather-forecast-icons';
  const bottomRightClass = previewMode ? 'bottom-right-preview-mode' : 'bottom-right';
  const weatherDescClass = previewMode ? 'weather-description-preview-mode' : 'weather-description';
  const hourTextClass = previewMode ? xs ? 'text-[0.8rem]' : 'text-[1.0rem]' : 'text-[1.5vw]';
  const hourIconStyle = previewMode ? xs ? { width: '35px' } : { width: '50px' } : { width: '5vw' };

  return (
    <div ref={containerWeatherAreaRef} className={`${containerClass} ${languageRtl ? 'flex-row-reverse' : ''}`}
      style={{
        backgroundColor: weatherBgColor,
        background: weatherBgColor,
        color: weatherTextColor
      }}
    >


      {/* style={isDay ? { background: 'linear-gradient(180deg, #3c5fb1, #4e7ee4)' } : { background: 'linear-gradient(180deg,rgb(37, 37, 37),rgb(18, 30, 56))' }}    > */}

      <div className={paneLeftClass}
        // style={xs ? { width: '35%' } : {}}
        style={{
          display: hide ? "flex" : "",
          flexDirection: hide ? languageRtl ? "row" : "row-reverse" : "",
          justifyContent: hide ? languageRtl ? "end" : "start" : "",
          alignItems: hide ? "center" : "",
          gap: hide ? "2vw" : "",
          width: xhide ? "50%" : "",

        }}
      >
        <div className={topLeftClass}>
          <div className={`${cityTitleClass} ${languageRtl ? 'text-end' : ''}`}>{display_name}</div>
          <div
            style={xs ? { fontSize: '0.75rem' } : {}}
            className={`d-flex align-items-center ${dateRowClass} ${languageRtl ? ' flex-row-reverse' : ''}`}>
            <div className={dateTagClass}
              style={{ backgroundColor: weatherCardColor }}

            >{langTranslate["today"]}</div>
            <div style={xs ? { fontSize: '0.75rem' } : {}} className="d-flex align-items-center date-weather-live flex-column">
              <div>{currentDay}</div>
              <div>{time}</div>
            </div>
          </div>
        </div>
        <div className={weatherIconClass}>
          <img src={getWeatherIcon(isDay, data?.current?.condition?.code)} className="img-fluid" style={
            previewMode ? xs ? { width: '140px' } : { width: '240px' } : xhide?{width: '85vh' }:{ width: '20vw' }} alt="icon" />
        </div>
        <div className={weatherDescRightClass}
          style={{
            display: hide ? "none" : "",
          }}
        >{data?.current?.condition?.text}</div>
      </div>

      <div className={paneRightClass} style={xhide ? { width: '50%' } : {}}>
        <div className={`${topRightClass} ${languageRtl ? 'flex-row-reverse' : ''}`}
          style={{
            justifyContent: languageRtl ? "start" : "",
          }}
        >
          <div className="temp-weather-feels px-4" style={xs ? { fontSize: '0.9rem' } : {}}>
            {languageRtl ? (
              <>
                {isCelsius ? Math.round(data?.current?.feelslike_c) : Math.round(data?.current?.feelslike_f)}
                °{langTranslate["feels_like"]}
              </>
            ) : (
              <>
                {langTranslate["feels_like"]}
                {isCelsius ? Math.round(data?.current?.feelslike_c) : Math.round(data?.current?.feelslike_f)}   °
              </>
            )}
          </div>

          <div className={`d-flex align-items-start ${justifyEndClass}`}>
            <div className={currentTempValueClass} style={{
              fontSize: xhide ? `${dimensions.height * 0.65}px` : "",
            }}>{isCelsius ? Math.round(data?.current?.temp_c) : Math.round(data?.current?.temp_f)}</div>
            <div className={currentTempUnitClass}>°{isCelsius ? 'C' : 'F'}</div>
          </div>
        </div>


        {!xhide && (<div className={`${forecastRowClass} ${languageRtl ? 'flex-row-reverse' : ''}`}>
          {forecastDays.slice(0, 3).map((forecast, idx) => (
            <div key={idx} className={forecastCardClass} style={xs ? { backgroundColor: weatherCardColor, padding: '10px' } : { backgroundColor: weatherCardColor }}>
              <div>
                <div style={xs ? { fontSize: "0.7rem" } : {}}>{weekDays[idx]}</div>
                <div className="d-flex align-items-center" style={xs ? { fontSize: '0.5rem' } : {}}>
                  <span>{isCelsius ? Math.round(forecast?.day?.maxtemp_c) : Math.round(forecast?.day?.maxtemp_f)}°</span>
                  <span className="slash mx-1">/</span>
                  <span>{isCelsius ? Math.round(forecast?.day?.mintemp_c) : Math.round(forecast?.day?.mintemp_f)}°</span>
                </div>
              </div>
              <img src={getWeatherIcon(1, forecast?.day?.condition?.code)} className={`${forecastIconClass} img-fluid`} style={previewMode ? xs ? { width: '30px' } : { width: '40px' } : { width: '5vw' }} alt="forecast" />
            </div>
          ))}
        </div>)}

        {!hide && (<div className={bottomRightClass}>
          <div className={`${weatherDescClass} ${languageRtl ? 'text-end' : ''}`} style={xs ? { fontSize: '0.9rem' } : {}}>{data?.current?.condition?.text}</div>
          <div className={`w-full h-full gap-4 flex items-center justify-center p-4 ${languageRtl ? 'flex-row-reverse' : ''}`}>
            {[8, 12, 15, 18, 20, 23].map((hr, idx) => (
              <div key={idx} className="w-100 text-center d-flex flex-column justify-center gap-3 items-center">
                <div className={hourTextClass}>{`${hr}:00`}</div>
                <img
                  src={getWeatherIcon(hr > 18 ? 0 : 1, todayHours[hr]?.condition?.code)}
                  className={`${forecastIconClass} img-fluid TEXT-CENTER`}
                  style={hourIconStyle}
                  alt="hour"
                />
                <div className={hourTextClass}>{isCelsius ? Math.round(todayHours[hr]?.temp_c) : Math.round(todayHours[hr]?.temp_f)}°</div>
              </div>
            ))}
          </div>
        </div>)}
      </div>
    </div >
  );
};

export default WeatherPreviewUnified;
